import * as React from "react";
import CenterDiv from "../core/CenterDiv";
import { getOrgUsers, updateOwner } from "../../libs/organization";
import FilterInput from "../core/FilterInput";
import Card from "../core/Card";
import Panel from "../core/Panel";
import toast from "../../utils/toast";
import * as H from "history";
import Modal from "../core/Modal";

interface IProps {
  org: IOrganization;
  routerHistory: H.History;
  updateOwner: (IUser) => void;
}

interface IState {
  users: INormalizedObject[];
  selectedUser: INormalizedObject;
  searching: boolean;
  searchValue: string;
  confirmModalOpen: boolean;
}

class OrgTransfer extends React.Component<IProps, IState> {
  state: Readonly<IState> = {
    searching: false,
    selectedUser: null,
    searchValue: "",
    users: [],
    confirmModalOpen: false,
  };

  componentDidMount() {
    this.getUsers();
  }

  getUsers = async () => {
    this.setState({ searching: true });
    const users = await getOrgUsers(this.props.org.id);
    this.setState({ searching: false, users: users });
  };

  updateOwner = async () => {
    this.setState({ confirmModalOpen: false });
    const user = this.state.selectedUser;
    if (user) {
      document.getElementById("transition-overlay")!.style.display = "block";
      const result = await updateOwner(this.props.org, {
        ownerId: user.id,
        orgId: user.organizationId,
      });
      if (result.status == "ok") {
        toast.success("Successfully changed owner");
        this.props.updateOwner(user);
        this.props.routerHistory.push("/");
      } else {
        toast.error("Unable to change user");
      }
    }
    document.getElementById("transition-overlay")!.style.display = "none";
  };

  render() {
    const {
      users,
      selectedUser,
      searching,
      searchValue,
      confirmModalOpen,
    } = this.state;

    const list = users
      .filter(u => {
        if (!searchValue) return true;
        const filterChars = searchValue.toUpperCase();
        const nameMatches = u.name.toUpperCase().includes(filterChars);
        const emailMatches = u.email.toUpperCase().includes(filterChars);
        return nameMatches || emailMatches;
      })
      .map(c => {
        if (!c.isOwner)
          return (
            <tr key={c.id}>
              <td>{c.name}</td>
              <td>{c.jobTitle}</td>
              <td>{c.email}</td>
              <td>
                <button
                  className="btn btn-theme-primary"
                  onClick={() => this.setState({ selectedUser: c })}
                >
                  Choose
                </button>
              </td>
            </tr>
          );
      });

    return (
      <>
        <Card title={"Transfer Ownership"}>
          {selectedUser ? (
            <>
              <hr />
              <p> New owner has been selected: </p>
              <hr />
              <table className={"table"}>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Title</th>
                    <th>Email</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{selectedUser.name}</td>
                    <td>{selectedUser.jobTitle}</td>
                    <td>{selectedUser.email}</td>
                    <td>
                      <button
                        className="btn btn-theme-danger"
                        onClick={() =>
                          this.setState({ selectedUser: undefined })
                        }
                      >
                        Unset
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <CenterDiv>
                <button
                  className={"btn btn-theme-primary btn-lg"}
                  onClick={() => this.setState({ confirmModalOpen: true })}
                >
                  Transfer Ownership
                </button>
              </CenterDiv>
            </>
          ) : (
            <>
              <hr />
              <p> Select a user to transfer ownership to </p>
              <hr />
              <FilterInput
                placeholder={"Filter Users"}
                value={searchValue}
                onChange={searchValue => this.setState({ searchValue })}
              />
              <br />
              {searching ? (
                <CenterDiv>
                  <i className="fa fa-spin fa-3x fa-circle-o-notch" />
                </CenterDiv>
              ) : (
                <table className={"table"}>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Title</th>
                      <th>Email</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>{list}</tbody>
                </table>
              )}
            </>
          )}
        </Card>
        <Modal
          title={"Confirmation"}
          onSubmit={this.updateOwner}
          open={confirmModalOpen}
          close={() => this.setState({ confirmModalOpen: false })}
        >
          <div>
            {selectedUser
              ? `Please confirm that you want to transfer ownership to ${
                  selectedUser.name
                }`
              : "No user selected"}
          </div>
        </Modal>
      </>
    );
  }
}

export default OrgTransfer;



// WEBPACK FOOTER //
// ./app/javascript/components/org/OrgTransfer.tsx